import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import purchasesService from '../services/purchasesService';
import PurchaseOrderForm from '../components/PurchaseOrderForm';
import { useNotification } from '../context/NotificationContext';
import '../styles/general.css';

const PurchaseOrderFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const isEditMode = !!id;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (!isEditMode) return;

    const fetchOrder = async () => {
      try {
        const res = await purchasesService.getPurchaseOrderById(id);
        setOrder(res.data);
      } catch (err) {
        console.error('Error loading purchase order:', err);
        notify.error(t('common.failedToLoad'));
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id, isEditMode, t, notify]);

  if (loading) {
    return <div className="loading">{t('common.loading')}</div>;
  }

  // The backend rejects writes to a cancelled order, so the edit form would be
  // a dead end. Send the user to the read-only view instead of letting them
  // fill it in and hit a 400 on save.
  if (isEditMode && order && !order.is_active) {
    return <Navigate to={`/purchases/${order.id}`} replace />;
  }

  return (
    <div className="page-container-wide">
      {/* page-header pushes its last child to the right, so the folio sits
          opposite the title instead of running on after it. */}
      <div className="page-header">
        <h1>{isEditMode ? t('purchases.editTitle') : t('purchases.createTitle')}</h1>
        {isEditMode && order?.order_number && (
          <div className="order-number-badge">
            <span className="order-number-label">{t('purchases.orderNumber')}</span>
            <span className="order-number-value">{order.order_number}</span>
          </div>
        )}
      </div>

      <PurchaseOrderForm
        initialData={order}
        onSuccess={() => navigate('/purchases')}
        onCancel={() => navigate('/purchases')}
      />
    </div>
  );
};

export default PurchaseOrderFormPage;
